// src/app/axios/nonce.ts
//
// Nonces are one-time use — the server deletes each one once it's consumed,
// so every signed request needs a freshly-fetched nonce.

import { bareClient } from "./bareClient";

// Deduplicate concurrent fetches for the (shared, unauthenticated) public nonce.
let publicNonceInFlight: Promise<string | null> | null = null;

/**
 * Nonce used to sign public (unauthenticated) write requests — login,
 * register, password reset, guest submissions, etc.
 */
export async function getPublicNonce(): Promise<string | null> {
  if (publicNonceInFlight) return publicNonceInFlight;
  publicNonceInFlight = bareClient
    .get("/auth/nonce/public")
    .then(({ data }) => data?.nonce_token ?? null)
    .catch(() => {
      console.error("[Nonce] public nonce fetch failed");
      return null;
    })
    .finally(() => {
      publicNonceInFlight = null;
    });
  return publicNonceInFlight;
}

/**
 * Nonce used to sign authenticated write requests. Not cached or
 * deduplicated — each authenticated write needs its own fresh nonce.
 */
export async function getApiNonce(): Promise<string | null> {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    const { data } = await bareClient.get("/auth/nonce", {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data?.nonce_token ?? null;
  } catch {
    console.error("[Nonce] api nonce fetch failed");
    return null;
  }
}